import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  list: null,
  current: null,
}

const participantSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEventsList: (state, action) => ({ ...state, list: action.payload }),
    setCurrentEvent: (state, action) => ({ ...state, current: action.payload }),
  }
})

export const { setEventsList, setCurrentEvent } = participantSlice.actions
export default participantSlice.reducer
